import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/branch-course-categories';

function sanitizeParams(params = {}) {
  const result = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed !== '') result[key] = trimmed;
      return;
    }
    result[key] = value;
  });
  return result;
}

export async function listCourseCategories(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, { params: sanitizeParams(params) });
  return response.data;
}

export async function createCourseCategory(payload) {
  const response = await axiosInstance.post(BASE_PATH, payload);
  return response.data;
}

export async function updateCourseCategory(id, payload) {
  const response = await axiosInstance.put(`${BASE_PATH}/${id}`, payload);
  return response.data;
}

export async function deleteCourseCategory(id) {
  const response = await axiosInstance.delete(`${BASE_PATH}/${id}`);
  return response.data;
}
